import { ProductOption } from '../../features/refiTransactions/types'

interface stateProp {
  selectedOptions: { productId: string; productOption: ProductOption }[]
  selectedSurcharges: string[]
}

const initialState: stateProp = {
  selectedOptions: [],
  selectedSurcharges: [],
}

const applicationCoverageState = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_PRODUCT_OPTION_STATE':
      // TODO: currently we only allow the selection of one product option
      //  but we might need to be able to select multiple again
      // const productToAdd = state.selectedOptions.find(
      //   (option) => option.productId === action.payload.productId
      // )
      // if (productToAdd) {
      //   const productIndex = state.selectedOptions.indexOf(productToAdd)
      //   state.selectedOptions[productIndex] = action.payload
      // } else {
      //   state.selectedOptions.push(action.payload)
      // }

      return {
        selectedOptions: action.payload ? [action.payload] : [],
        selectedSurcharges: state.selectedSurcharges || [],
      }

    case 'CLEAR_PRODUCT_OPTION_STATE':
      const productToClean = state.selectedOptions.find(
        (option) => option.productId === action.payload.productId
      )
      if (productToClean) {
        const productIndex = state.selectedOptions.indexOf(productToClean)
        state.selectedOptions.splice(productIndex, 1)
      }
      return {
        ...state,
      }

    case 'UPDATE_SURCHARGES_STATE':
      const surchargeCode = action.payload.surchargeCode
      if (state.selectedSurcharges.includes(surchargeCode)) {
        const surchargeCodeIndex =
          state.selectedSurcharges.indexOf(surchargeCode)
        state.selectedSurcharges.splice(surchargeCodeIndex, 1)
      } else {
        state.selectedSurcharges.push(surchargeCode)
      }
      return {
        ...state,
      }

    case 'RESET_COVERAGE_DETAILS_STATE':
      return initialState
    default:
      return state
  }
}

export default applicationCoverageState

export const selectCoverageProducts = (state) => {
  return state.refis.applicationCoverageState
}
